import { Box, Button, IconButton, Typography } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import QuestionSearchBar from "./QuestionSearchBar";

const QuestionTopToolbar = ({
  questionCount,
  searchText,
  setSearchText,
  onCreateClick,
  onToggleFilter,
  handleSearch,
  handleClearSearch
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1,
      }}
    >
      <Box sx={{
        flex: 0.3,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        mb: 0,
        height: '100%'
      }}>
        <Typography sx={{ flex: 1, width: 'auto', textAlign: 'left', fontWeight: 800, fontSize: 18 }}>Total-Questions : {questionCount}</Typography>
      </Box>

      <QuestionSearchBar searchText={searchText} setSearchText={setSearchText} handleSearch={handleSearch} handleClearSearch={handleClearSearch} />

      <Box sx={{
        flex: 0.2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 0,
        height: '100%'
      }}>

      </Box>

      <Box sx={{
        flex: 0.2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 0,
        height: '100%'
      }}>

        <Button
          variant="contained"
          color="success"
          sx={{ borderRadius: 2, textTransform: "none", mr: 2, height: '100%', width: '200px' }}
          onClick={() => {
            onCreateClick();
          }}
        >
          Create Question
        </Button>

        <IconButton onClick={onToggleFilter} size='large'>
          <FilterListIcon />
        </IconButton>

      </Box>

    </Box>
  );
}


export default QuestionTopToolbar;